<!-- 楼盘资讯 -->
<template>
  <div class="">
    <!-- 导航头部组件 -->
    <HeaderNav chooseNav="1"></HeaderNav>
    <div class="img_box">
      <div class="pc_img">
        <img alt="" :src="pcImg" style="width: 100%; height: auto;" />
      </div>
      <div class="wap_img">
        <img alt="" :src="wapImg" style="width: 100%; height: auto;" />
      </div>
    </div>
    <hr class="hr_1 mt0 mb30">
    <!-- 脚步导航组件 -->
    <FooterNav></FooterNav>
  </div>
</template>

<script>
import HeaderNav from '../../components/HeaderNav';
import FooterNav from '../../components/FooterNav';
import RightNav from '../../components/RightNav.vue';
import { apiStatePage, apiGetList } from '../../api/message.js';
import { apiGetCity, apiSunmitOperateIntent } from '../../api/login.js';
export default {
  name: 'Index',
  components: {
    HeaderNav: HeaderNav,
    FooterNav: FooterNav,
    RightNav: RightNav
  },
  data() {
    return {
      pcImg:'',
      wapImg:'',
    };
  },
  created() {
    if(this.$route.query.id==1){
      this.pcImg = 'static/picture/1-210G2153033945.jpg'
      this.wapImg= 'static/picture/1-210G21530131I.jpg'
    }
    if(this.$route.query.id==2){
      this.pcImg = 'static/picture/1-21012Q13IG31.jpg'
      this.wapImg= 'static/picture/1-21012Q13Gc02.jpg'
    }
    if(this.$route.query.id==3){
      this.pcImg = 'static/picture/1-21012Q130035Y.jpg'
      this.wapImg= 'static/picture/1-21012Q13023938.jpg'
    }
  },
  methods: {

  }
};
</script>
<style scoped>
  @media screen and (max-width: 768px) {
    .pc_img{
    	display: none;
    }
    .wap_img{
    	display: block;
    }
  }

@media (min-width: 768px){
	.nav li {
		padding: 0 15px;
	}
	.pc_img{
		display: none;
	}
	.wap_img{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: block;
	}
}



@media (min-width: 1110px) {



	.pc_img{
		display: block;
	}
	.wap_img{
		display: none;
	}
	.img_box .video_box .zhezhao img.img_pc{
		display: block;
	}
	.img_box .video_box .zhezhao img.img_wap{
		display: none;
	}
}
/*------------brand.html  start----------------*/
.img_box{
	width: 100%;
	overflow: hidden;
	margin: 0 auto;
}
.img_box img{
	max-width: 100%;
	margin: 0 auto;
	display: block;
}
.img_box .video_box{
	width: 100%;
	margin: 0 auto;
	position: relative;
}
.img_box .video_box .zhezhao{
	position: absolute;
	height: 100%;
	width: 100%;
	left: 0px;
	top: 0px;
	z-index: 555;
	overflow: hidden;
	cursor: pointer;
}
.img_box .video_box .zhezhao img{
	width: 100%;
	height: 100%;
	transition:all 1s ease-in-out;
}
.img_box .video_box .zhezhao img.img_pc{
	display: block;
}
.img_box .video_box .zhezhao img.img_wap{
	display: none;
}
.img_box .video_box video{
	width: 100%;
}
/*------------brand.html  end----------------*/
</style>



// WEBPACK FOOTER //
// src/view/Message/Index.vue